const CheckMark = () => {
  return (
    <svg
      id="Vrstva_1"
      data-name="Vrstva 1"
      xmlns="http://www.w3.org/2000/svg"
      width="180.6mm"
      height="180.6mm"
      baseProfile="tiny"
      version="1.2"
      viewBox="0 0 511.9 511.9"
      className="mt-0.5 h-5 w-5"
    >
      <path
        d="M347.7,176.8l30,30.4-123.6,121.7c-8.3,8.3-19.1,12.4-30,12.4s-21.9-4.2-30.2-12.5l-59.3-57.5,29.7-30.7,59.6,57.7,123.9-121.6h0ZM512,256c0,141.2-114.8,256-256,256S0,397.2,0,256,114.8,0,256,0s256,114.8,256,256ZM469.3,256c0-117.6-95.7-213.3-213.3-213.3S42.7,138.4,42.7,256s95.7,213.3,213.3,213.3,213.3-95.7,213.3-213.3Z"
        fill="#0fa55a"
        strokeWidth="0"
      />
    </svg>
  )
}

export default CheckMark
